import type { FC } from 'react';
import { Redirect } from 'react-router-dom';
import { Box, Card, CardContent, Typography } from '@mui/material';
import VerifyCodeForm from '~/components/authentication/login/VerifyCodeForm';
import { Status, useLoginContext } from './LoginContext';
import { MfaWay } from '~/entry/types';



export const VerifyCodeCater: FC = () => {
  const { states, Create } = useLoginContext()
  return (
    states.status === Status.Phase2 ? 
      <Create resource="login-confirm">
        <VerifyCode /> 
      </Create>
      : 
      <Redirect to="/login" />
  )
}


const VerifyCode: FC = () => {
  const { states } = useLoginContext()

  return (
    <Card>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', p: 4 }} >
        <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', mb: 3 }} >
          <div>
            <Typography color="textPrimary" gutterBottom variant="h4" >
              Verify Code
            </Typography>
            <Typography color="textSecondary" variant="body2" sx={{ mt: 4 }} >
              A verification code has been sent to your 
              {states.phase1Result!.mfaWay === MfaWay.Email ? ' email address ' : ' mobile phone '}
              in your profile 
              {states.phase1Result!.mfaWay === MfaWay.Email ? (' ' + maskEmail(states.phase1Result!.email!)) : (' with the last 4 digits of ' + states.phase1Result!.phoneTail)}.
              Please enter the verification code below.
            </Typography>
          </div>
        </Box>
        <Box sx={{ flexGrow: 1, mt: 3 }} >
          <VerifyCodeForm />
        </Box>
        {/* <Divider sx={{ my: 3 }} />
        <Link
          color="textSecondary"
          component={RouterLink}
          to="/authentication/password-recovery"
          variant="body2"
        >
          Did you not receive the code?
        </Link> */}
      </CardContent>
    </Card>
  );
};

export default VerifyCode;

const maskEmail = (s:string) => {
  const i = (s ?? '').lastIndexOf('@')
  return (i > -1 
    ? `******${s.substring(i)}` 
    : '')
}
